<template>
<v-container fluid>
    <!-- <button @click="showAlert">Hello world</button>
      <button @click="showAlertConfirm">Hello world</button>-->
    <v-row>
        <v-col cols="12">
            <v-app-bar color="#0177b2" dense dark>
                <v-icon color="white" class="header-icon-space">mdi-dropbox</v-icon>
                <v-toolbar-title>User
                    <!-- {{myname}}ss{{this.itemListtbd}}-->{{this.itemListtbd}}
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn small fab falt right="right" color="#049be6" @click="getall()">
                    <v-icon color="white">mdi-refresh</v-icon>
                </v-btn>

            </v-app-bar>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" class="text-right">

            <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on" @click="addnewitem()">
                        <v-icon right dark> mdi-clipboard-arrow-right </v-icon>
                        <span class="button-caption">Add New</span>
                    </v-btn>
                </template>
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">User</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>

                                <v-text-field v-model="name" :counter="50" :rules="nameRules" label="User Name" required></v-text-field>
                                <v-text-field v-model="loginid" :counter="200" :rules="nameRules" label="Login Id" required></v-text-field>
                                <v-text-field v-if="isShowpwd" v-model="strpassword" :counter="50" label="User Password" required></v-text-field>
                                <v-select v-model="itemRole" :items="roleList" item-text="name" item-value="id" return-object label="Role">
                                </v-select>
                                <v-checkbox v-model="isactive" label="Is Active"></v-checkbox>
                            </v-container>
                            <small>*indicates required field</small>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeForm()">
                                Close
                            </v-btn>
                            <v-btn :disabled="!valid" color="blue darken-1" text @click="addupdate()">
                                Save
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-col>
    </v-row>
    <v-row>

        <v-col cols="12">
            <app-widget title="User" headingicon="true" titleicon="mdi-chart-bell-curve">
                <div slot="widget-content">
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left text-capitalize" style="width:15px !important;">#</th>
                                    <th class="text-center text-capitalize">User Name</th>
                                    <th class="text-center text-capitalize">Country</th>
                                    <th class="text-center text-capitalize">Brand</th>
                                    <th class="text-center text-capitalize">Level</th>
                                    <th class="text-left text-capitalize" style="width:50px !important;">IsActive</th>
                                    <th class="text-center text-capitalize" style="width:150px !important;">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="items in itemList" :key="items.id">
                                    <td>{{ items.id }}</td>
                                    <td class="text-center ">{{ items.user__username }}</td>
                                    <td class="text-center ">{{ items.country__name }}</td>
                                    <td class="text-center ">{{ items.brand__name }}</td>
                                    <td class="text-center ">{{ items.level__name }}</td>
                                    <td>
                                        <div v-if="!items.isactive">
                                            <v-icon class="inactive-bg">mdi-alpha-x</v-icon>
                                        </div>
                                        <div v-else>
                                            <v-icon class="inactive-bg-green">mdi-check</v-icon>
                                        </div>
                                    </td>

                                    <td>
                                        <v-btn small icon @click="showEditdilog(items.id)">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn small icon @click="showAlertConfirm(items.id)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                         <v-btn small icon @click="showEditdilogforpwd(items.id)">
                                            <v-icon>mdi-account-key-outline</v-icon>
                                        </v-btn>

                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </app-widget>

        </v-col>
    </v-row>

</v-container>
</template>

<script>
import {
    mapActions,
    mapState
} from 'vuex'
import AppWidget from "../../../components/AppWidget.vue";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import apifactory from "../api"
Vue.use(VueAxios, axios);
export default {
    components: {
        AppWidget,

    },
    data() {
        return {
            dialog: false,
            valid: true,
            isShowpwd: true,
            itemListtbd: [],
            itemList: [],
            itemRole: '',
            itemRoledefalut: {"id": 0,
"name": "Select"},

            name: "",
            strpassword: "",
            loginid: "",
            id: 0,
            roleid: "",
            isactive: true,

            appusername: "manish",
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length <= 50) || 'Name must be less than 50 characters',
            ],

        };
    },
    mounted() {
         this.roleList =this.roleList.push;
        //this.itemListtbd=this.itemRoledefalut.concate(this.roleList);
        this.getall();
    },
    computed: {
        ...mapState("configuration", ["roleList"])
    },
    methods: {
        ...mapActions("configuration", ["roleGetAll"]),
        addnewitem() {
            this.isShowpwd = true;
        },
        validate() {
            this.$refs.form.validate()
        },
        reset() {
            this.$refs.form.reset()
        },
        resetValidation() {
            this.$refs.form.resetValidation()
        },
        closeForm() {
            this.reset();
            this.isShowpwd = true;
            this.dialog = false;

        },

        showAlertConfirm(id) {
            this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    this.delete(id);
                    this.$swal(
                        'Deleted!',
                        'Your Data has been deleted.',
                        'success'
                    )
                }
            });
        },
        addupdate() {
            //alert('fddd');
            //alert(this.id);
            //alert(this.countryId);
            if (this.id != 0) {
                //this.isShowpwd = false;
                this.update();
            } else {
                //this.isShowpwd = true;
                this.addnew();
            }
        },
        showEditdilog(id) {
            this.id = id;
            this.isShowpwd = false;
            this.getbyID(id);
        },
        showEditdilogforpwd(id) {
            this.id = id;
            this.isShowpwd = true;
            this.getbyID(id);
        },
        getall() {
            //alert('dd');
            //let ll=apibase.call

            apifactory.cbluGetAll()
                .then((res) => {

                    if (res.status != 200) {
                        this.itemList = null;
                        // alert(this.processdataitems.length);

                    } else {
                        this.itemList = res.data;
                        // alert(res);
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        getbyID(id) {

            apifactory
                .getbyid(id)
                .then((res) => {
                    // alert(res.status);

                    if (res.status != 200) {
                        //this.countryList = null;
                        // alert(this.processdataitems.length);

                    } else {
                        this.itemListtbd = res.data;

                        this.name = res.data.username;
                        this.strpassword = res.data.strpassword;
                        this.loginid = res.data.loginid;
                        this.roleid = res.data.role;
                        this.isactive = res.data.isactive;
                        this.dialog = true;
                        //this.itemRole= [{id: res.data.role, name: res.data.role__name}];
                        this.itemRole = {
                            "id": res.data.role,
                            "name": res.data.role__name

                        };
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        update() {

            apifactory.update(this.id, this.name, this.loginid, this.appusername,this.itemRole.id, this.isactive,this.strpassword,this.isShowpwd)
                .then((res) => {
                    // alert(res.status);

                    if (res.status != 200) {
                        //this.countryList = null;
                        // alert(this.processdataitems.length);

                    } else {
                        this.id = 0;
                        this.reset();
                        this.dialog = false;
                        this.getall();

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },

        addnew() {

            //let apiurl = apifactory.countryAdd(this.countryName, this.currencyCode, "manish"); // "http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/country/?name=" + this.countryName + "&currencycode=" + this.currencyCode + "&isactive=" + this.isActive;
            //alert(this.itemRole.id);
           apifactory.addNew(this.name,this.strpassword,this.loginid,this.appusername,this.itemRole.id,this.isactive)
                .then((res) => {
                     //alert(res.status);

                    if (res.status != 200) {
                        //this.countryList = null;
                         alert(res.message);

                    } else {
                        this.id = 0;
                        this.reset();
                         this.getall();
                        this.dialog = false;
                       

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        delete(id) {

            //let apiurl = apifactory.countryDelete(id); // "http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/country/?id=" + id + "&isdisable=true";

            apifactory.delete(id)
                .then((res) => {
                    // alert(res.status);

                    if (res.status != 200) {
                        //this.countryList = null;
                        // alert(this.processdataitems.length);

                    } else {
                        this.id = 0;
                        this.reset();
                        this.getall();
                        this.dialog = false;
                        

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        }
    }
};
</script>

<style scoped>
.inactive-bg {

    color: red;
}

.inactive-bg-green {

    color: green;
}
</style>
